__turbopack_context__.v({
  "content": "BG8LJW_content",
  "goBackBtn": "BG8LJW_goBackBtn",
  "homePageBtn": "BG8LJW_homePageBtn",
  "iconWrapper": "BG8LJW_iconWrapper",
  "link": "BG8LJW_link",
  "main": "BG8LJW_main",
  "nav": "BG8LJW_nav",
  "text__fRbnz": "BG8LJW_text__fRbnz",
  "text__jb0XZ": "BG8LJW_text__jb0XZ",
  "text__mqh": "BG8LJW_text__mqh",
  "text__mvNvr": "BG8LJW_text__mvNvr",
  "text__nd3Xf": "BG8LJW_text__nd3Xf",
  "text__vz5Ro": "BG8LJW_text__vz5Ro",
  "title": "BG8LJW_title",
  "wrapper": "BG8LJW_wrapper",
});
